// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* red */\n/* orange */\n/* yellow */\n/* green */\n/* teal */\n/* aqua */\n/* blue */\n/* purple */\n/* magenta */\n/* gray */\n", "",{"version":3,"sources":["webpack://./../shared/style/baseColors.css"],"names":[],"mappings":"AAAA,QAAQ;AASR,WAAW;AAOX,WAAW;AAOX,UAAU;AAOV,SAAS;AAOT,SAAS;AAOT,SAAS;AAST,WAAW;AAOX,YAAY;AAOZ,SAAS","sourcesContent":["/* red */\n@value colorRedMacmillan:     #da1b2c;\n@value colorRedLightest:      #ffe7e5;\n@value colorRedLighter:       #ffafaf;\n@value colorRedMedium:        #ef5656;\n@value colorRedDark:          #da1b2c;\n@value colorRedDarkest:       #a51426;\n@value colorVeryLightRed:     #ffe7e5;\n\n/* orange */\n@value colorOrangeLightest:   #ffe5d3;\n@value colorOrangeLighter:    #ffc196;\n@value colorOrangeMedium:     #ff8a57;\n@value colorOrangeDarker:     #dd5714;\n@value colorOrangeDarkest:    #a83d0e;\n\n/* yellow */\n@value colorYellowLightest:   #fffbd7;\n@value colorYellowLighter:    #faf2a9;\n@value colorYellowMedium:     #e5d676;\n@value colorYellowDarker:     #b79e25;\n@value colorYellowDarkest:    #74600c;\n\n/* green */\n@value colorGreenLightest:    #daf4d4;\n@value colorGreenLighter:     #acdba2;\n@value colorGreenMedium:      #68b75f;\n@value colorGreenDarker:      #3b822e;\n@value colorGreenDarkest:     #2c5e20;\n\n/* teal */\n@value colorTealLightest:     #dbfff3;\n@value colorTealLighter:      #aee5d3;\n@value colorTealMedium:       #5fb79c;\n@value colorTealDarker:       #218466;\n@value colorTealDarkest:      #16664b;\n\n/* aqua */\n@value colorAquaLightest:     #cff3f9;\n@value colorAquaLighter:      #a2d6dd;\n@value colorAquaMedium:       #45a5b5;\n@value colorAquaDarker:       #00758e;\n@value colorAquaDarkest:      #205460;\n\n/* blue */\n@value colorBlueLightest:     #e0f1ff;\n@value colorBlueLighter:      #b0daff;\n@value colorBlueMedium:       #3192d3;\n@value colorBlueDarker:       #006eb8;\n@value colorBlueDarkest:      #004c72;\n@value colorBlueTopBar:       #142A35;\n@value colorInterface:        #142A35;\n\n/* purple */\n@value colorPurpleLightest:   #ffe6fd;\n@value colorPurpleLighter:    #e5c6e3;\n@value colorPurpleMedium:     #b286af;\n@value colorPurpleDarker:     #865f7f;\n@value colorPurpleDarkest:    #543b50;\n\n/* magenta */\n@value colorMagentaLightest:  #ffe6f3;\n@value colorMagentaLighter:   #edb0ce;\n@value colorMagentaMedium:    #b26487;\n@value colorMagentaDarker:    #882345;\n@value colorMagentaDarkest:   #562135;\n\n/* gray */\n@value colorGrayLightest:     #f8f8f8;\n@value colorGrayLight:        #f3f3f3;\n@value colorGrayMedium:       #dddddd;\n@value colorGrayMediumDark:   #c8c8c8;\n@value colorGrayDark:         #989898;\n@value colorGrayDarker:       #686868;\n@value colorGrayDarkest:      #383838;\n@value colorBlackish:         #080808;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colorRedMacmillan": "#da1b2c",
	"colorRedLightest": "#ffe7e5",
	"colorRedLighter": "#ffafaf",
	"colorRedMedium": "#ef5656",
	"colorRedDark": "#da1b2c",
	"colorRedDarkest": "#a51426",
	"colorVeryLightRed": "#ffe7e5",
	"colorOrangeLightest": "#ffe5d3",
	"colorOrangeLighter": "#ffc196",
	"colorOrangeMedium": "#ff8a57",
	"colorOrangeDarker": "#dd5714",
	"colorOrangeDarkest": "#a83d0e",
	"colorYellowLightest": "#fffbd7",
	"colorYellowLighter": "#faf2a9",
	"colorYellowMedium": "#e5d676",
	"colorYellowDarker": "#b79e25",
	"colorYellowDarkest": "#74600c",
	"colorGreenLightest": "#daf4d4",
	"colorGreenLighter": "#acdba2",
	"colorGreenMedium": "#68b75f",
	"colorGreenDarker": "#3b822e",
	"colorGreenDarkest": "#2c5e20",
	"colorTealLightest": "#dbfff3",
	"colorTealLighter": "#aee5d3",
	"colorTealMedium": "#5fb79c",
	"colorTealDarker": "#218466",
	"colorTealDarkest": "#16664b",
	"colorAquaLightest": "#cff3f9",
	"colorAquaLighter": "#a2d6dd",
	"colorAquaMedium": "#45a5b5",
	"colorAquaDarker": "#00758e",
	"colorAquaDarkest": "#205460",
	"colorBlueLightest": "#e0f1ff",
	"colorBlueLighter": "#b0daff",
	"colorBlueMedium": "#3192d3",
	"colorBlueDarker": "#006eb8",
	"colorBlueDarkest": "#004c72",
	"colorBlueTopBar": "#142A35",
	"colorInterface": "#142A35",
	"colorPurpleLightest": "#ffe6fd",
	"colorPurpleLighter": "#e5c6e3",
	"colorPurpleMedium": "#b286af",
	"colorPurpleDarker": "#865f7f",
	"colorPurpleDarkest": "#543b50",
	"colorMagentaLightest": "#ffe6f3",
	"colorMagentaLighter": "#edb0ce",
	"colorMagentaMedium": "#b26487",
	"colorMagentaDarker": "#882345",
	"colorMagentaDarkest": "#562135",
	"colorGrayLightest": "#f8f8f8",
	"colorGrayLight": "#f3f3f3",
	"colorGrayMedium": "#dddddd",
	"colorGrayMediumDark": "#c8c8c8",
	"colorGrayDark": "#989898",
	"colorGrayDarker": "#686868",
	"colorGrayDarkest": "#383838",
	"colorBlackish": "#080808"
};
export default ___CSS_LOADER_EXPORT___;
